import { Blocks, FormInput, Plus, Workflow } from "lucide-react";
import { Badge, Button, Card } from "../components/ui";

export function ProductFactoryPage() {
  return (
    <div className="page-stack">
      <div className="page-actions">
        <p>Crie novas verticais sem copiar o código principal.</p>
        <Button>
          <Plus size={16} /> Nova vertical
        </Button>
      </div>
      <section className="product-grid">
        <Card>
          <div className="product-title">
            <div className="product-icon">
              <FormInput />
            </div>
            <div>
              <h2>Campos e formulários</h2>
              <p>Cadastro configurável</p>
            </div>
            <Badge tone="success">ATIVO</Badge>
          </div>
          <ul className="feature-list">
            <li>Campos por entidade e tenant</li>
            <li>Visibilidade condicional</li>
            <li>Validação e dados sensíveis</li>
            <li>Formulários públicos e internos</li>
          </ul>
          <Button variant="secondary">Abrir construtor</Button>
        </Card>
        <Card>
          <div className="product-title">
            <div className="product-icon">
              <Workflow />
            </div>
            <div>
              <h2>Workflows</h2>
              <p>Máquinas de estado declarativas</p>
            </div>
            <Badge tone="success">ATIVO</Badge>
          </div>
          <ul className="feature-list">
            <li>Requisitos por transição</li>
            <li>Ações idempotentes</li>
            <li>Fila e retentativas</li>
            <li>Auditoria integral</li>
          </ul>
          <Button variant="secondary">Abrir workflows</Button>
        </Card>
        <Card className="combo-card">
          <div className="product-title">
            <div className="product-icon">
              <Blocks />
            </div>
            <div>
              <h2>Verticais disponíveis</h2>
              <p>Planos e Benefícios · Patrimônio e Recebíveis</p>
            </div>
            <Badge tone="info">2 PRODUTOS</Badge>
          </div>
          <p>
            O mesmo núcleo atende novos segmentos por catálogo, formulários, workflows, documentos,
            permissões e relatórios configuráveis.
          </p>
        </Card>
      </section>
    </div>
  );
}
